export var itemListFilterDefaults = {
  includeFiles: true,
  includeFolders: true,
  isReadByClientUser: null,
  grouping: null
};
